module.exports = __webpack_public_path__ + "static/media/ungroup-tool-white.cee28771.svg";